import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { PopupContent } from 'new-ui/Components/Popup';
import Form from 'new-ui/Components/Form';
import styles from './nextScanChat.module.css';

const dateFormatter = (date = new Date()) => moment(date).format('MM/DD/YYYY');

export const NextScanChat = ({ nextScan, onSubmit }) => {
  const [form, setForm] = useState({
    inputs: {
      nextScan: {
        type: 'date',
        minDate: new Date(),
        default: 'MM/DD/YYYY',
        formatter: dateFormatter,
      },
    },
    data: {
      nextScan,
      notScheduled: null,
    },
  });

  const handleRadioChange = (name, newValue) => {
    form.data[name] = newValue;
    setForm({ ...form });

    onSubmit({ nextScan: form.data.nextScan });
  };

  return (
    <PopupContent>
      <div className={styles.root}>
        <Form
          inputs={form.inputs}
          data={form.data}
          popupMode
          onChange={handleRadioChange}
          onSubmit={() => onSubmit({ nextScan: form.data.nextScan })}
        />
        <div className={styles.placeholder} />
      </div>
    </PopupContent>
  );
};

NextScanChat.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  nextScan: PropTypes.string,
};
